module.exports = __webpack_public_path__ + "img/industries.0a3773df.svg";